import axios from 'axios'
import store from '../store'
import { getToken, setToken} from '@/utils/auth'
import { isSuccess } from '@/utils/util'
import { refreshToken } from '@/api/admin/login'
import { Message } from 'element-ui'
import errorCode from '@/const/errorCode'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
const whiteList = ['/login', '/register']// 白名单

// 超时时间
const instance = axios.create({
  // baseURL: 'https://train-video.qybenan.com',
  // baseURL: 'http://192.168.110.70:8013',
  timeout: 60000,
  withCredentials: true
})

// 跨域请求，允许保存cookie
NProgress.configure({ showSpinner: false })// NProgress Configuration
// HTTP request拦截
instance.interceptors.request.use(config => {
  NProgress.start() // start progress bar
  if (store.getters.token && whiteList.indexOf(config.url) === -1) {
    const authorization = config.headers['Authorization']
    if (authorization === undefined || authorization.indexOf('Basic') === -1) {
      config.headers['Authorization'] = getToken() // 让每个请求携带token
    }
  }
  return config
}, error => {
  return Promise.reject(error)
})

// HTTP response拦截
instance.interceptors.response.use(data => {
  NProgress.done()
  
  // 判断是否是 overContentAddLearnTime 接口
  const isOverContentAddLearnTime = data.config && data.config.url && 
    data.config.url.includes('overContentAddLearnTime');
  
  // 如果是 overContentAddLearnTime 接口，直接返回整个响应
  if (isOverContentAddLearnTime) {
    return data;
  }
  
  // 请求失败，弹出提示信息
  if (!isSuccess(data.data)) {
    // token失效
    if (data.data.code === 401) {
      Message({ message: 'token 失效，请重新登录！', type: 'error' })
      store.dispatch('LogOut').then(() => {
        location.href = '/index';
      })
    } else if (data.data.code === 9000) {
      Message({ message: data.data.msg, type: 'error' })
      location.href = '/tip?tip=' + data.data.msg;
    } else if (data.data.code === 500) {
      if (data.data.msg  == '用户名或密码错误') {
        data.data.msg = '用户名或密码错误,请联系培训管理员'
      }
      Message({ message: data.data.msg || errorCode['default'], type: 'error' });
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject('error');
    }
  }
  return data.data
}, error => {
  NProgress.done()
  
  // 判断是否是 overContentAddLearnTime 接口
  const isOverContentAddLearnTime = error.config && error.config.url && 
    error.config.url.includes('overContentAddLearnTime');
  
  // 如果是 overContentAddLearnTime 接口，直接返回整个错误响应
  if (isOverContentAddLearnTime) {
    return Promise.reject(error);
  }
  
  if (error.response) {
    const { code, msg } = error.response.data
    const errMsg = errorCode[String(code)] || msg || errorCode['default']
    Message({ message: errMsg, type: 'error' })
    // }
  }
  return Promise.reject(new Error(error));
})

export default instance



// WEBPACK FOOTER //
// ./src/router/axios.js